import React from "react";
import { haptic } from "@/lib/telegram";

export function QuantityStepper({
  quantity,
  onChange,
  max,
}: {
  quantity: number;
  onChange: (next: number) => void;
  max?: number;
}) {
  return (
    <div className="stepper">
      <button
        onClick={() => {
          haptic("selection");
          onChange(quantity - 1);
        }}
        aria-label="Decrease quantity"
      >
        −
      </button>
      <span>{quantity}</span>
      <button
        onClick={() => {
          if (max !== undefined && quantity >= max) return;
          haptic("selection");
          onChange(quantity + 1);
        }}
        aria-label="Increase quantity"
        disabled={max !== undefined && quantity >= max}
        style={{ opacity: max !== undefined && quantity >= max ? 0.4 : 1 }}
      >
        +
      </button>
    </div>
  );
}
